module.exports = __webpack_public_path__ + "img/update.be8ce04c.svg";